var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Triangle_1",
    "data-name": "Triangle 1",
    width: 15,
    height: 13,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAAwElEQVQokZXRv0oDQRAH4M/gC/kKKXycgH8wYGVSSAqLYJNUAas0KWwsQirJC6RId51YCMHGIiJKIgMXOI69cPerZmfnK3bn5HXSnuNc87y0cIW/hvQXF4HXGDXEj8ha+aGHz5pwg34UBxzwria+xVcRR8b5E45lhcnhvojj0y6PwD062KVwZIHnCjzDstgo48gNfkq9b1yXB1M4w7DUe8BbHRy5x0dev2OQGqrCsYpYSaSLbWrotAJHnnCGafIW/1nfJUSzkx/TAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleYellow);
export default __webpack_public_path__ + "static/media/triangle-yellow.92c44e5dae7b0907330c229ad18677c5.svg";
export { ForwardRef as ReactComponent };